export default "__VITE_ASSET__D5wTJcIB__"